export default __webpack_public_path__ + "static/monnify-logo-b563208727c6c54b2e4702c2ef2d7ff7.png";